import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _SVGIconWithSizes;

import { createSvg } from "../createSvg";
import { IconSize, SVGIconWithSizes } from "../interfaces";
export default createSvg('IconSearch', new SVGIconWithSizes((_SVGIconWithSizes = {}, _defineProperty(_SVGIconWithSizes, IconSize.ExtraSmall, {
  paths: ['M16.6588 15.4088L12.1132 10.8632C14.0678 8.25279 13.6728 4.57566 11.2084 2.43995C8.74392 0.304236 5.04799 0.436126 2.74204 2.74207C0.4361 5.04801 0.304209 8.74395 2.43992 11.2084C4.57563 13.6728 8.25277 14.0678 10.8632 12.1132L15.4087 16.6588C15.5733 16.8268 15.7986 16.9214 16.0337 16.9214C16.2689 16.9214 16.4942 16.8268 16.6588 16.6588C16.8267 16.4942 16.9214 16.2689 16.9214 16.0338C16.9214 15.7986 16.8267 15.5733 16.6588 15.4088ZM2.78346 7.19267C2.78346 5.40369 3.86173 3.79109 5.51497 3.10754C7.16821 2.42399 9.07046 2.80428 10.3338 4.07091C11.5972 5.33754 11.9726 7.24075 11.2848 8.89223C10.597 10.5437 8.98161 11.6178 7.19264 11.6132C6.02128 11.6132 4.89806 11.1471 4.07085 10.3178C3.24364 9.48844 2.78044 8.36403 2.78346 7.19267V7.19267Z'],
  params: {
    height: '17',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), _defineProperty(_SVGIconWithSizes, IconSize.Small, {
  paths: ['M3 8C3 5.243 5.243 3 8 3C10.757 3 13 5.243 13 8C13 10.757 10.757 13 8 13C5.243 13 3 10.757 3 8M18.707 17.293L13.599 12.185C14.475 11.016 15 9.569 15 8C15 4.141 11.859 1 8 1C4.141 1 1 4.141 1 8C1 11.859 4.141 15 8 15C9.569 15 11.016 14.475 12.185 13.599L17.293 18.707C17.488 18.902 17.744 19 18 19C18.256 19 18.512 18.902 18.707 18.707C19.098 18.316 19.098 17.684 18.707 17.293'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), _defineProperty(_SVGIconWithSizes, IconSize.Medium, {
  paths: ['M3.60001 9.6C3.60001 6.2916 6.29161 3.6 9.60001 3.6C12.9084 3.6 15.6 6.2916 15.6 9.6C15.6 12.9084 12.9084 15.6 9.60001 15.6C6.29161 15.6 3.60001 12.9084 3.60001 9.6M22.4484 20.7516L16.3188 14.622C17.37 13.2192 18 11.4828 18 9.6C18 4.9692 14.2308 1.2 9.60001 1.2C4.96921 1.2 1.20001 4.9692 1.20001 9.6C1.20001 14.2308 4.96921 18 9.60001 18C11.4828 18 13.2192 17.37 14.622 16.3188L20.7516 22.4484C20.9856 22.6824 21.2928 22.8 21.6 22.8C21.9072 22.8 22.2144 22.6824 22.4484 22.4484C22.9176 21.9792 22.9176 21.2208 22.4484 20.7516'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), _defineProperty(_SVGIconWithSizes, IconSize.Large, {
  paths: ['M4.79998 12.8C4.79998 8.38879 8.38878 4.79999 12.8 4.79999C17.2112 4.79999 20.8 8.38879 20.8 12.8C20.8 17.2112 17.2112 20.8 12.8 20.8C8.38878 20.8 4.79998 17.2112 4.79998 12.8M29.9312 27.6688L21.7584 19.496C23.16 17.6256 24 15.3104 24 12.8C24 6.62558 18.9744 1.59998 12.8 1.59998C6.62558 1.59998 1.59998 6.62558 1.59998 12.8C1.59998 18.9744 6.62558 24 12.8 24C15.3104 24 17.6256 23.16 19.496 21.7584L27.6688 29.9312C27.9808 30.2432 28.3904 30.4 28.8 30.4C29.2096 30.4 29.6192 30.2432 29.9312 29.9312C30.5568 29.3056 30.5568 28.2944 29.9312 27.6688'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));